import { SET_CURRENT_VARIANT } from "./actionTypes";

const setCurrentVariant = (variantResult) => {
  return {
    type: SET_CURRENT_VARIANT,
    result: {
      variantResult,
    },
  };
};

export { setCurrentVariant };
